// extracted by mini-css-extract-plugin
export default {"title":"AcknowledgementAndConsent_title__WKYLD","bodyText":"AcknowledgementAndConsent_bodyText__eR5a+","buttonContainer":"AcknowledgementAndConsent_buttonContainer__hngi0"};